import React from 'react';
import PropTypes from 'prop-types';

import RoutedSavableApp from 'platform/forms/save-in-progress/RoutedSavableApp';
import { useBrowserMonitoring } from 'platform/monitoring/Datadog';
import formConfig from '../config/form';

export default function MedicalExpenseReportApp({ location, children }) {
  useBrowserMonitoring({ service: 'benefits-medical-expense-report' });
  return (
    <RoutedSavableApp formConfig={formConfig} currentLocation={location}>
      {children}
    </RoutedSavableApp>
  );
}

MedicalExpenseReportApp.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
};
